// AdSquare
import ActiveSportsEnthusiasts from '@/common/icons/audience-segments/adSquare/ActiveSportsEnthusiasts';
import BeautyAndWellnessEnthusiasts from '@/common/icons/audience-segments/adSquare/Beauty&WellnessEnthusiasts';
import BusinessTravellers from '@/common/icons/audience-segments/adSquare/BusinessTravellers';
import CarBuyers from '@/common/icons/audience-segments/adSquare/CarBuyers';
import CarEnthusiasts from '@/common/icons/audience-segments/adSquare/CarEnthusiasts';
import CinemaAddicts from '@/common/icons/audience-segments/adSquare/CinemaAddicts';
import ConsumerElectronicsBuyers from '@/common/icons/audience-segments/adSquare/ConsumerElectronicsBuyers';
import EntertainmentLovers from '@/common/icons/audience-segments/adSquare/EntertainmentLovers';
import FashionLovers from '@/common/icons/audience-segments/adSquare/FashionLovers';
import FinanceSavvy from '@/common/icons/audience-segments/adSquare/FinanceSavvy';
import FootballFans from '@/common/icons/audience-segments/adSquare/FootballFans';
import HealthAndFitnessEnthusiasts from '@/common/icons/audience-segments/adSquare/HealthAndFitnessEnthusiasts';
import HouseholdLeader from '@/common/icons/audience-segments/adSquare/HouseholdLeader';
import InsuranceSeekers from '@/common/icons/audience-segments/adSquare/InsuranceSeekers';
import LuxuryShoppers from '@/common/icons/audience-segments/adSquare/LuxuryShoppers';
import MusicAndNightlifeLovers from '@/common/icons/audience-segments/adSquare/Music&NightlifeLovers';
import OrganicAndEcoConscious from '@/common/icons/audience-segments/adSquare/Organic&EcoConscious';
import OutdoorSportsEnthusiasts from '@/common/icons/audience-segments/adSquare/OutdoorSportsEnthusiasts';
import ParentsWithBabiesAtHome from '@/common/icons/audience-segments/adSquare/ParentsWithBabiesAtHome';
import ParentsWithKindergardenKidsAtHome from '@/common/icons/audience-segments/adSquare/ParentsWithKindergardenKidsAtHome';
import ParentsWithSchoolchildrenAtHome from '@/common/icons/audience-segments/adSquare/ParentsWithSchoolchildrenAtHome';
import PetOwner from '@/common/icons/audience-segments/adSquare/PetOwner';
import Singles from '@/common/icons/audience-segments/adSquare/Singles';
import TechAndGadgetLovers from '@/common/icons/audience-segments/adSquare/Tech&GadgetLovers';
import Tourists from '@/common/icons/audience-segments/adSquare/Tourists';
import TVLightViewerVideoStreamers from '@/common/icons/audience-segments/adSquare/TVLightViewer-VideoStreamers';
import AlcoholicBeverageConsumers from '@/common/icons/audience-segments/eqWorks/AlcoholicBeverageConsumers';
import AutoIntenders from '@/common/icons/audience-segments/eqWorks/AutoIntenders';
import BeautySpenders from '@/common/icons/audience-segments/eqWorks/BeautySpenders';
import DiyHomeRenovators from '@/common/icons/audience-segments/eqWorks/DiyHomeRenovators';
import Entrepreneurs from '@/common/icons/audience-segments/eqWorks/Entrepreneurs';
import Fashionistas from '@/common/icons/audience-segments/eqWorks/Fashionistas';
import FastFoodDiners from '@/common/icons/audience-segments/eqWorks/FastFoodDiners';
import Gamers from '@/common/icons/audience-segments/eqWorks/Gamers';
import HealthFitnessEnthusiasts from '@/common/icons/audience-segments/eqWorks/HealthFitnessEnthusiasts';
import HomeChefEnthusiasts from '@/common/icons/audience-segments/eqWorks/HomeChefEnthusiasts';
import HomeDecorators from '@/common/icons/audience-segments/eqWorks/HomeDecorators';
import MovieGoers from '@/common/icons/audience-segments/eqWorks/MovieGoers';
// EQWorks
import OnlineShoppers from '@/common/icons/audience-segments/eqWorks/OnlineShoppers';
import OutdoorEnthusiasts from '@/common/icons/audience-segments/eqWorks/OutdoorEnthusiasts';
import PetOwners from '@/common/icons/audience-segments/eqWorks/PetOwners';
import PrimaryGroceryShoppers from '@/common/icons/audience-segments/eqWorks/PrimaryGroceryShoppers';
import RetailBankingCustomers from '@/common/icons/audience-segments/eqWorks/RetailBankingCustomers';
import SportsEnthusiasts from '@/common/icons/audience-segments/eqWorks/SportsEnthusiasts';
import TechEnthusiasts from '@/common/icons/audience-segments/eqWorks/TechEnthusiasts';
import TravelEnthusiasts from '@/common/icons/audience-segments/eqWorks/TravelEnthusiasts';

export default [
  // AdSquare
  { code: '670151', icon: Singles },
  { code: '670128', icon: CarBuyers },
  { code: '670158', icon: CarEnthusiasts },
  { code: '670146', icon: FinanceSavvy },
  { code: '670150', icon: EntertainmentLovers },
  { code: '670155', icon: MusicAndNightlifeLovers },
  { code: '670156', icon: HouseholdLeader },
  { code: '670144', icon: BeautyAndWellnessEnthusiasts },
  { code: '670168', icon: HealthAndFitnessEnthusiasts },
  { code: '670139', icon: OrganicAndEcoConscious },
  { code: '670149', icon: CinemaAddicts },
  { code: '670157', icon: TVLightViewerVideoStreamers },
  { code: '670152', icon: InsuranceSeekers },
  { code: '670147', icon: PetOwner },
  { code: '670143', icon: ActiveSportsEnthusiasts },
  { code: '670160', icon: FootballFans },
  { code: '670161', icon: OutdoorSportsEnthusiasts },
  { code: '670162', icon: FashionLovers },
  { code: '670167', icon: LuxuryShoppers },
  { code: '670148', icon: ConsumerElectronicsBuyers },
  { code: '670165', icon: TechAndGadgetLovers },
  { code: '670159', icon: BusinessTravellers },
  { code: '670154', icon: Tourists },
  { code: '670163', icon: ParentsWithBabiesAtHome },
  { code: '670138', icon: ParentsWithKindergardenKidsAtHome },
  { code: '670141', icon: ParentsWithSchoolchildrenAtHome },
  // EQWorks
  { code: 'ONLINE-SHOPPERS', icon: OnlineShoppers },
  { code: 'OUTDOOR-ENTHUSIASTS', icon: OutdoorEnthusiasts },
  { code: 'RETAIL-BANKING-CUSTOMERS', icon: RetailBankingCustomers },
  { code: 'TRAVEL-ENTHUSIASTS', icon: TravelEnthusiasts },
  { code: 'HEALTH-AND-FITNESS-ENTHUSIASTS', icon: HealthFitnessEnthusiasts },
  { code: 'SPORTS-ENTHUSIASTS', icon: SportsEnthusiasts },
  { code: 'AUTO-INTENDERS', icon: AutoIntenders },
  { code: 'FAST-FOOD-DINERS', icon: FastFoodDiners },
  { code: 'PRIMARY-GROCERY-SHOPPERS', icon: PrimaryGroceryShoppers },
  { code: 'MOVIE-GOERS', icon: MovieGoers },
  { code: 'GAMERS', icon: Gamers },
  { code: 'HOME-DECORATORS', icon: HomeDecorators },
  { code: 'ALCOHOLIC-BEVERAGE-CONSUMERS', icon: AlcoholicBeverageConsumers },
  { code: 'HOME-CHEF-ENTHUSIASTS', icon: HomeChefEnthusiasts },
  { code: 'TECH-ENTHUSIASTS', icon: TechEnthusiasts },
  { code: 'DIY-AND-HOME-RENOVATORS', icon: DiyHomeRenovators },
  { code: 'FASHIONISTAS', icon: Fashionistas },
  { code: 'PET-OWNERS', icon: PetOwners },
  { code: 'BEAUTY-SPENDERS', icon: BeautySpenders },
  { code: 'ENTREPRENEURS', icon: Entrepreneurs },
];
